/**
 * 获取类型
 * @param {Object} v 
 * @returns 
 */
 function getType(v) {
  return Object.prototype.toString.call(v)
}

/**
 * 判断两个类型是否相等
 * @param {*} oldV 
 * @param {*} newV 
 * @returns 
 */
function typeIs(oldV, newV) {
  return getType(oldV) === getType(newV);
}

/**
 * 判断是否为数组对象,或二维数组
 * @param {*} arr 
 */
function isArrObject(arr) {
  return Array.isArray(arr) && arr.some(item => item && typeof item === 'object')
}

/**
 * 对数组进行排序,返回排序后的数组
 * @param {*} arr 
 * @param {*} field 排序的字段,多个字段则用逗号隔开,'Province,City'
 */
function newArrSort(arr = [], field = '') {
  if (Array.isArray(arr) && !isArrObject(arr)) return arr.map(item => String(item)).sort((a, b) => a.localeCompare(b))
  return arr
}


/**
 * 数组比较
 * @param {*} oldArr 
 * @param {*} newArr 
 */
function arrCompare(oldArr, newArr, userIds = []) {
  return newArr.reduce((pre, curr, index) => {
    if (Array.isArray(curr)) {
      pre.push(arrCompare(newArrSort(oldArr[index] || []), newArrSort(curr)))
    } else if (curr && typeof curr === 'object') {
      let oldValue = curr.ID ? oldArr.find(item => item.ID == curr.ID) : oldArr[index]
      if (curr.Months) oldValue = oldArr.find(item => item.Months == curr.Months)
      pre.push(objCompare(oldValue || {}, curr, userIds))
    } else {
      pre.push({
        isChange: JSON.stringify(curr) != JSON.stringify(oldArr[index]),
        orignData: oldArr[index],
        changeData: curr
      })
    }
    return pre
  }, [])
}

/**
 * 两个对象比较
 * @param {*} oldObj 
 * @param {*} newObj 
 */
function objCompare(oldObj, newObj, userIds = []) {
  let newDataArr = Object.entries(newObj);
  return newDataArr.reduce((pre, curr) => {
    pre.userIds = userIds
    let key = curr[0],
      val = key === 'Areas' ? curr[1].map(item => item.Province + '/' + item.City).sort((a, b) => a.localeCompare(b)) : curr[1];
    if (key === 'Areas' && Array.isArray(oldObj[key])) {
      oldObj[key] = oldObj[key].map(item => item.Province + '/' + item.City).sort((a, b) => a.localeCompare(b));
    }
    if (key === 'DockingPeopleIds') {
      let newIds = val || []
      let oldIds = oldObj[key] || []
      pre.userIds.push(...newIds, ...oldIds);
    }
    switch (getType(val)) {
      case "[object Object]":
        pre[key] = objCompare(oldObj[key] || {}, val, pre.userIds)
        break;
      case "[object Array]":
        // 判断是否为简单的数组类型[1,2,3,4]
        if (!isArrObject(val)) {
          let arrParams = key == 'Areas' || key == 'ProjectTypes' ? oldObj[key] || null : oldObj[key] || [];
          let changeData = newArrSort(val);
          let originData = newArrSort(arrParams);
          pre[key] = {
            isChange: JSON.stringify(originData) != JSON.stringify(changeData),
            originData,
            changeData
          }
        } else {
          pre[key] = arrCompare(newArrSort(oldObj[key] || []), newArrSort(val), pre.userIds)
        }
        break;
      default:
        let originData = oldObj[key],
          changeData = val
        pre[key] = {
          isChange: originData !== changeData,
          originData,
          changeData
        }
        break;
    }
    return pre;
  }, {
    userIds: []
  });
}


export default arrCompare
